<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g><path data-follow-fill="currentColor" d="M512 73c248.6 0 445.5 200.4 439.9 450.4-5.3 234.4-195 424.2-429.4 429.4C272.4 958.5 72 761.6 72 513 72 267.9 266.9 73 512 73zm0 62.9c-209.4 0-380.4 173-377.1 383.1 3.2 203.1 168 368 371.2 371.1 210.1 3.3 383.1-167.7 383.1-377.1-.1-207.4-169.8-377.1-377.2-377.1zM402.4 284 512 393.6l110.1-110.1c12.1-12.1 31.7-12.1 43.8 0 12.2 12.2 12.2 32 0 44.2L543.4 450.1H638c17.2 0 31.2 14 31.2 31.2 0 17.5-14.2 31.7-31.7 31.7h-94v62.9h94.3c17.4 0 31.4 14.1 31.4 31.4 0 17.4-14.1 31.4-31.4 31.4h-94.3V733c0 17.4-14.1 31.4-31.4 31.4-17.4 0-31.4-14.1-31.4-31.4v-94.3h-94.3c-17.4 0-31.4-14.1-31.4-31.4 0-17.4 14.1-31.4 31.4-31.4h94.3V513h-97.6c-15.5 0-28.1-12.6-28.1-28.1v-.6c0-18.9 15.3-34.2 34.2-34.2h91.5l-123-123c-11.9-11.9-11.9-31.2 0-43.1 12.3-12.4 32.3-12.4 44.7 0zM380 261.6" :fill="_fill" /></g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
